import type { ReactNode } from 'react';
import * as Menu from '@radix-ui/react-dropdown-menu';
import { content, item, separator } from './Dropdown.css';

export function Dropdown({ trigger, children, align = 'end' }: {
  trigger: ReactNode; children: ReactNode; align?: 'start' | 'center' | 'end';
}) {
  return (
    <Menu.Root>
      <Menu.Trigger asChild>{trigger}</Menu.Trigger>
      <Menu.Portal>
        <Menu.Content className={content} align={align} sideOffset={8}>
          {children}
        </Menu.Content>
      </Menu.Portal>
    </Menu.Root>
  );
}

export function DropdownItem({ children, onSelect, danger, disabled }: {
  children: ReactNode; onSelect?: () => void; danger?: boolean; disabled?: boolean;
}) {
  return (
    <Menu.Item
      className={item}
      onSelect={onSelect}
      disabled={disabled}
      data-danger={danger ? 'true' : undefined}
    >
      {children}
    </Menu.Item>
  );
}

export function DropdownSeparator() {
  return <Menu.Separator className={separator} />;
}
